import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DistributorManufacturer } from '../distributor-manufacturer.model';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ManagePlanComponent } from '../manage-plan/manage-plan.component';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-manufacturers',
    templateUrl: './manufacturers.component.html',
    styleUrls: ['./manufacturers.component.scss'],
    standalone: false
})
export class ManufacturersComponent implements OnInit {
  showSearch: boolean;
  searchForm!: FormGroup;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null
  };

  manufacturersList = new Array<DistributorManufacturer>();
  searchValue = "";

  constructor(private router: Router, public dataService: DataService, private authService: AuthService,
              private route: ActivatedRoute,
              public utils: UtilsService,
              public dialog: MatDialog,
              private exportService: ExportService
              ) {
    this.showSearch = false;
    this.route.queryParams.subscribe((params: Params) => {
      if (!this.isEmpty(params)) {
        this.pageNumber = params.pageNumber ? params.pageNumber : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.searchValue =  params.searchValue ? params.searchValue : "";
      }
      this.getManufacturer();
    });
   }

  ngOnInit(): void {
    this.utils.setTitle('Manufacturers');
    this.utils.screenTitle.emit({firstTitle: 'Manufacturers', firstRoute: '/manufacturers'});
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  getManufacturer() {
    this.dataService.get('manufacturer/RetrieveManufacturers?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.manufacturersList = [];
        const manufacturersData = data.data.records;
        this.totalSize = data.data.count;
        manufacturersData.forEach((manufacturerData: any) => {
          const manufacturerInstance = new DistributorManufacturer(manufacturerData);
          this.manufacturersList.push(manufacturerInstance);
        });
        if (manufacturersData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
          this.router.navigate(['/manufacturers'], { queryParams: this.queryParams });
        }
      }
    });
  }

  managePlan(item: any) {
    const dialogRef = this.dialog.open(ManagePlanComponent, {
      disableClose: true,
      width: '400px',
      data: {
        currentPlan: item.plan,
        id: item.id,
      }
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
    this.router.navigate(['/manufacturers'], { queryParams: this.queryParams });
  }
  handleSearchClick() {
    if (this.showSearch && this.manufacturersList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  onImgError(event: any) {
    this.utils.theme$.subscribe(isDark => {
      event.target.src  = isDark
        ? '../../../assets/images/distributor-dark.png'
        : '../../../assets/images/distributor-light.png';
    });
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
      this.router.navigate(['/manufacturers'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue
    };
    this.router.navigate(['/manufacturers'], { queryParams: this.queryParams });
  }

  goToManufacturer(name: any, id: number) {
    this.router.navigate(['/manufacturers/manufacturer/' + id + '/' + name]);
  }

  async block(id: any){
    await this.utils.blockUser(id, this.dataService);
    this.getManufacturer();
  }

  async unblock(id: any){
    await this.utils.unBlockUser(id, this.dataService);
    this.getManufacturer();
  }

  exportManufacturers(fileTypeId: number) {
    this.exportService.exportFile('manufacturer/ExportManufacturers', fileTypeId, this.searchValue, 'manufacturers');
  }
}
